import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { HTML_LANG, normalizeLanguage } from "../i18n/languages";

export function useDocumentLang() {
  const { t, i18n } = useTranslation("common");

  useEffect(() => {
    const lang = normalizeLanguage(i18n.language);
    document.documentElement.lang = HTML_LANG[lang];
    document.title = t("meta.title");

    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute("content", t("meta.description"));
    }
  }, [i18n.language, t]);
}
